<template>
  <component :is="layout">
    <transition>
      <router-view></router-view>
    </transition>
    <CookieLaw theme="dark-lime">
      a
      <div slot-scope="props" class="col">
        <p>
          🍪 Na našem spletnem mestu uporabljamo piškotke, ki so nujno potrebni
          za delovanje spletnega mesta in so nameščeni samodejno.
          <a
            href="https://brevisvelox.com/#/privacy"
            target="_blank"
            class="btn btn-sm btn-outline-light ml-2"
            ><span class="text-white">Več informacij</span></a
          ><a
            class="btn btn-sm btn-light mr-2 float-right"
            @click="props.close"
          >
            <span>OK</span>
          </a>
        </p>
      </div>
    </CookieLaw>
  </component>
</template>

<script>
const default_layout = "default";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/css/style.css";
import "@/assets/css/colors/default.css";
import "@/assets/css/snow.min.css";
import CookieLaw from "vue-cookie-law";

export default {
  name: "App",
  components: { CookieLaw },
  computed: {
    isLoggedIn: function() {
      return this.$store.getters["login/isLoggedIn"];
    },

    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
  },
};
</script>
